import React from 'react'
import MainHeader from '../views/MainHeader'
import HomeBody from '../views/HomeBody'
import Loading from '../views/common/Loading'
import SeasonAlert from '../views/SeasonAlert'
import Home from '../styles/home'

export default ({ loyalty }) => {
  if (!loyalty.status) return <Loading />

  const {
    status: {
      point,
      tierType,
      finishedRides,
      currentSeason: {
        title
      },
      nextSeason,
    },
    tiers,
    featuredItems,
  } = loyalty

  return (
    <>
      <SeasonAlert planetType={tierType} planets={tiers} />
      <Home>
        <MainHeader
          title={title}
          planetType={tierType}
          point={point}
          backgroundImage={require(`../planets/${tierType.toLowerCase()}.jpg`)}
          goHome={() => window.parent.postMessage('onLoyaltyClosed', '*')}
          tiers={tiers}
        />
        <HomeBody
          finishedRides={finishedRides}
          planets={tiers}
          featuredItems={featuredItems}
          nextSeason={nextSeason}
          planetType={tierType}
          point={point}
        />
      </Home>
    </>
  )
}
